export const TOGGLE_BUTTONS_ARRAY_BUTTON = 'TOGGLE_BUTTONS_ARRAY_BUTTON'
export const SET_IS_SCROLLED = 'SET_IS_SCROLLED'

export const DISTRAINTS_CODES = ['D001', 'D004']
export const LINKAGES_CODES = ['RE06']
export const VIRTUAL_HEADQUOTERS = 'AD05'
export const CIA_NEWS_CODE = 'D0CN'

export const targets = { AD05: 'addresses' }
